import { render, staticRenderFns } from "./confectionDefaultModal.vue?vue&type=template&id=56e6340e&scoped=true&"
import script from "./confectionDefaultModal.vue?vue&type=script&lang=js&"
export * from "./confectionDefaultModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e6340e",
  null
  
)

export default component.exports